export const uiCapabilities = {
  admin: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canAccessFilesSection: true,
  },

  assistant_admin: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
    canAccessFilesSection: true,
  },

  order_management_specialist: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: true,
    canDownloadOrderInformationTemplate: true,
  },

  order_management_associate: {
    canDeleteOrder: true,
    canCancelOrder: true,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: true,
  },

  delivery_associate: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: true,
  },

  e_commerce_admin: {
    canDeleteOrder: false,
    canCancelOrder: false,
    canDownloadOrderInvoice: false,
    canDownloadOrderInformationTemplate: false,
  }
};